<template>
  <!--imagen banner-->
  <div :class="dataPanelFix.clase_contenedor">
    <img
      :src="dataPanelFix.imagen"
      :alt="dataPanelFix.alt"
      :class="dataPanelFix.imagen_clase"
      :loading="dataPanelFix.prioridad ? 'eager' : 'lazy'"
      :fetchpriority="dataPanelFix.prioridad ? 'high' : 'auto'"
      decoding="async"
    />
  </div>

  <!--CardBannerLocal-->
  <div class="flex flex-col absolute top-0 left-0 w-full md:w-[63%] h-full justify-center items-center px-6 md:px-0 pb-6 md:pb-0">

    <div class="flex flex-col gap-3 md:gap-2 w-auto">
      <h2 class="font-bold text-white text-base md:text-3xl leading-none">{{dataPanelFix.texto_superior}}</h2>
      
      <img :src="dataPanelFix.imagen_logo" :alt="`Logo ${dataPanelFix.alt}`" class="w-[30rem] h-auto" />
      
      <div class="text-white text-xs md:text-lg">
        <p>{{dataPanelFix.texto_inferior}}</p>
      </div>

      <!--Local boton-->
      <div class="text-left">
        <BotonAnimadoTipo1 texto="Llámanos"
          :svg-ancho="isMobile ? 18 : 24"
          :svg-alto="isMobile ? 18 : 24"
          button-classes="flex flex-row-reverse items-center bg-VERDE_TOP_CALIDAD font-bold text-white text-sm md:text-lg py-[0.3rem] md:py-1 px-[0.8rem] md:px-3 rounded hover:text-VERDE_TOP_CALIDAD hover:bg-white"
          :svg-tipo="4" :href="dataPanelFix.numero_local" />
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import BotonAnimadoTipo1 from '~/components/Botones/BotonAnimadoTipo1.vue'

const props = defineProps({
  dataPanelFix: { type: Object, required: true }
})

const isMobile = ref(false)

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  checkIsMobile()
  window.addEventListener('resize', checkIsMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkIsMobile)
})
</script>